import * as signalR from "@microsoft/signalr";

class SignalRService {
  _isConnected = false;
  _connection;

  configureConnection() {
    let userToken = localStorage.getItem("prodms_token");
    if (userToken) {
      this._connection = new signalR.HubConnectionBuilder()
        .withUrl("/signalr", {
          accessTokenFactory: () => userToken,
        })
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();
    } else {
      this._connection = new signalR.HubConnectionBuilder()
        .withUrl("/signalr")
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();
    }
  }

  async start() {
    console.log("Requesting SignalR connection.");
    try {
      await this._connection.start();
      this._connection;
      this._isConnected = true;
    } catch (err) {
      console.error("SignalR connection failed.", err);
    }
  }

  reconnect() {
    console.log("Reconnecting SignalR", this._connection);

    // Must copy the current methods over to the reconfigured connection.
    // (Connection must be reconfigured since auth token changes on new login.
    // Also, all existing methods are dropped after reconfiguring.)
    const methods = { ...this._connection.methods };
    this.stop();
    this.configureConnection();
    this._connection.methods = { ...this._connection.methods, ...methods };
    this.start();
  }

  stop() {
    if (this._isConnected) {
      this._connection.stop();
      this._isConnected = false;
    }
  }

  // Handle incoming new notifications from server.
  // Not to be confused with RaiseNotification - which follows an
  // action that triggers notification (invokes).
  // addNotification is the callback function
  receiveNotification(notificationReceiver) {
    this._connection.on("PushNotification", (newNotification) =>
      notificationReceiver(newNotification)
    );
  }

  raiseNotification(newNotification) {
    this._connection.invoke("RaiseNotification", newNotification);
  }

  receiveProjDataRefresh(dataRefresher) {
    this._connection.on("DataRefresh", (payload) => {
      console.log("Receiving DataRefresh", payload);
      dataRefresher(payload);
    });
  }

  receiveProjDashRefresh(dashRefresher) {
    this._connection.on("ProjDashRefresh", (payload) => {
      console.log("Receiving ProjDashRefresh");
      dashRefresher(payload);
    });
  }

  receiveProjAssignmentRefresh(dataRefresher) {
    this._connection.on("ProjAssignmentRefresh", (payload) => {
      console.log("Receiving ProjAssignmentRefresh");
      dataRefresher(payload);
    });
  }

  receiveUserProjectRolesRefresh(dataRefresher) {
    this._connection.on("UserProjectRolesRefresh", (payload) => dataRefresher(payload));
  }

  receivePdfRequest(requestCallback) {
    this._connection.on("PdfRequest", (payload) => requestCallback(payload));
  }

  receivePatchRequest(patchHandler) {
    this._connection.on("PatchRequest", (data) => patchHandler(data));
  }

  backgroundTaskToast_init(toastCallback) {
    this._connection.on("BackgroundTaskToast_Init", (payload) => {
      toastCallback(payload);
    });
  }

  backgroundTaskToast_progress(toastCallback) {
    this._connection.on("BackgroundTaskToast_Progress", (payload) => {
      toastCallback(payload);
    });
  }

  backgroundTaskToast_success(toastCallback) {
    this._connection.on("BackgroundTaskToast_Success", (payload) => {
      toastCallback(payload);
    });
  }

  backgroundTaskToast_fail(toastCallback) {
    this._connection.on("BackgroundTaskToast_Fail", (payload) => {
      console.log("BackgroundTaskToast_Fail");
      toastCallback(payload);
    });
  }
}

export default SignalRService;
